export const environment = {
  production: false,
  apiUrl: 'https://portal.api.dev1.aam.instantpaydev.aptyspayments.com',
  apiTokenServiceUrl: 'https://portal.api.dev1.aam.instantpaydev.aptyspayments.com',
  clientId: '9db3c035-d8cd-4562-8cef-250f4f882dda'
};
